import styled from 'styled-components';

import Text from 'components/Text';

export default styled(Text)`
  color: var(--gray);
  white-space: nowrap;
  font-family: var(--google-sora-cdn);
  font-size: 12.5px;
  font-weight: 800;
  text-align: center;
  margin: 0 0 20px;
`;
